(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Helpers = Lfl.Helpers || {};

    (function (Helpers, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Helpers, 'OnClickRedirector')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * This object allows for registering elements that can redirect to a page when clicked.
         *
         * Performs a GET method HTTP request when clicked, making the element de-facto an anchor (< a >) element.
         *
         * @memberOf Lfl.Helpers
         */
        Lfl.Helpers.OnClickRedirector = Helpers.OnClickRedirector || {};

        (function (OnClickRedirector, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Registration
             |-------------------------------------------------------------------------------------------------------------------
             */

            /**
             * The relative path to a clickable row inside a container.
             * @var {string}
             */
            const RELATIVE_ROW_PATH = '.clickable-row'

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * Registers redirection on click at any clickable row which is present inside the target at any given time.
             *
             * That is achieved by actually registering the handlers (i.e. listeners) to listen to a click on the target
             * and then evaluate if the clicked element was a clickable row.
             *
             * See http://api.jquery.com/on/ and the selector parameter for more info.
             *
             *
             * @param {string} targetQuery an identifier of the element that clickable table rows should be enabled for. E.g.,
             * '#some-id'.
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.registerAllRowsIn = function (targetQuery) {
                OnClickRedirector.registerOnClickRedirection(
                    $(targetQuery),
                    undefined, // We intentionally send an empty url to denote empty value.
                    RELATIVE_ROW_PATH
                );
            }

            /**
             * Registers the element to behave as a link to given when clicked (with or without ctrl/meta modifier or with
             * middle mouse button).
             *
             * @param {jQuery} $element
             * @param {string} [url]
             * @param {string|null} [selector] A selector string passed to the on event handlers to define only a specific
             * descendants of the $element, which should trigger the event.
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.registerOnClickRedirection = function ($element, url, selector) {
                if (typeof selector === 'undefined') {
                    selector = null;
                }

                // We have to register both a click handler and a mouseUp handler to fully simulate a link's behaviour.
                $element.on({
                        click: function (e) {
                            if (false === OnClickRedirector.wasElementWithOwnActionClicked(e)) {
                                var theUrl = typeof url === 'undefined' ? OnClickRedirector.getUrlFromElement($(this)) : url;
                                return OnClickRedirector.redirectOnClickEvent(theUrl, e);
                            }
                        },

                        // We have to register the mouseup event to handle middle mouse click.
                        // Source: http://stackoverflow.com/questions/1474575/jquery-click-function-doesnt-work-with-middle-button
                        mouseup: function (e) {
                            if (false === OnClickRedirector.wasElementWithOwnActionClicked(e)) {
                                var theUrl = typeof url === 'undefined' ? OnClickRedirector.getUrlFromElement($(this)) : url;
                                return OnClickRedirector.redirectOnMouseUpEvent(theUrl, e);
                            }
                        }
                    },
                    // Notice: the "this" value in the above handler methods is actually set to the clicked element defined by
                    // the selector, not the $element.
                    selector);
            }

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Event handling
             |-------------------------------------------------------------------------------------------------------------------
             */

            /**
             * Redirects to an address given by the target's url attribute and based on the event's attributes.
             *
             * TODO MOBA II - rename to redirectOnElementWithUrlClick and use the name for the method that truly performs just
             * the redirect based on already prepared data - performRedirect(string: url, boolean: openInNewTab)
             * @param clicked
             * @param event
             * @deprecated
             * @returns {boolean}
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.performRedirect = function (clicked, event) {
                if (this.wasElementWithOwnActionClicked(event) === false) {
                    var url = this.getUrlFromElement($(clicked));
                    return this.redirectOnClickEvent(url, event);
                }
            }

            /**
             * TODO MOBA II: internally call the refactored performRedirect(url, openInNewTab), mentioned above.
             *
             * @param {string} url
             * @param e
             * @returns {boolean}
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.redirectOnClickEvent = function (url, e) {

                // The ctrl key or meta key was held down. We can NOT catch middle mouse button here.
                if (e.metaKey || e.ctrlKey) {
                    this.openLinkInNewTab(url);
                } else {
                    // Href better simulates link click.
                    // Source: http://stackoverflow.com/a/506004/5500468
                    window.location.href = url;
                }
                return false;
            }

            /**
             * TODO MOBA II: Also internally call the refactored performRedirect(url, openInNewTab), mentioned above.
             *
             * @param {string} url
             * @param e
             * @returns {boolean}
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.redirectOnMouseUpEvent = function (url, e) {

                // The middle mouse click.
                if (e.which === 2) {
                    this.openLinkInNewTab(url);
                    return false;
                }
                return true;
            }

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Helpers
             |-------------------------------------------------------------------------------------------------------------------
             */

            /**
             * Loads the url from the element if the url is not defined.
             *
             * @param $element
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.getUrlFromElement = function ($element) {
                return $element.data("url");
            }

            /**
             *
             * @param {string} url
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.openLinkInNewTab = function (url) {
                // Source: http://stackoverflow.com/a/26823929/5500468
                window.open(url, '_blank');
                // Alternative if needed: http://stackoverflow.com/a/18639931/5500468
            }

            /**
             * Determines whether the element that was clicked (probably) has it's own event handler and therefore a different
             * action than plain redirection should be performed.
             *
             * @param event
             * @return boolean
             * @memberOf Lfl.Helpers.OnClickRedirector
             */
            OnClickRedirector.wasElementWithOwnActionClicked = function (event) {
                var clickedElement = event.target;
                var clickedElementType = ($(clickedElement).prop('nodeName')).toLowerCase();

                if (clickedElementType === 'a' || clickedElementType === 'button') {
                    return true;
                }

                if ($(clickedElement).parents('td a, td button').length >= 1) {
                    return true;
                }

                return false;
            }
        }(Helpers.OnClickRedirector, jQuery));
    }(Lfl.Helpers, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
